import { render, staticRenderFns } from "./space-hall.vue?vue&type=template&id=88d11376&scoped=true&"
import script from "./space-hall.vue?vue&type=script&lang=js&"
export * from "./space-hall.vue?vue&type=script&lang=js&"
import style0 from "./space-hall.vue?vue&type=style&index=0&id=88d11376&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d11376",
  null
  
)

export default component.exports